import axiosInstance from "../Axios/axiosInstance";

const getAllMenus = async () => {
  return await axiosInstance.get("/menus/");
};

const getMenuById = async (id) => {
  return await axiosInstance.get(`/menus/entry/${id}`);
};

const addMenu = async (data) => {
  console.log(data);
  return await axiosInstance.post("/menus/", data);
};

const editMenu = async (id, data) => {
  return await axiosInstance.put(`/menus/${id}`, data);
};

const deleteMenu = async (id) => {
  return await axiosInstance.delete(`/menus/${id}`);
};

export default {
  getAllMenus,
  getMenuById,
  addMenu,
  editMenu,
  deleteMenu,
};
